import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function marcasveiculo(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@marcasveiculo/FIND_MARCASVEICULO':
      case '@marcasveiculo/UPDATE_MARCASVEICULO':
      case '@marcasveiculo/DELETE_MARCASVEICULO':
      case '@marcasveiculo/STORE_MARCASVEICULO':
      case '@marcasveiculo/MARCASVEICULOS_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@marcasveiculo/SUCCESS_REMOVE':
      case '@marcasveiculo/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@marcasveiculo/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.marcasveiculos;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@marcasveiculo/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.marcasveiculo;
        break;
      }

      case '@marcasveiculo/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
